import { useMemo } from 'react';
import { useListView } from '../../core/ListViewProvider';

const ProjectSelection = ({ id, isDisabled = false }) => {
  const { selected, onSelect } = useListView();
  const isSelected = useMemo(() => selected.includes(id), [id, selected]);

  return (
    <div className='form-check form-check-sm form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer'
        }}
        type='checkbox'
        data-kt-check={isSelected}
        data-kt-check-target='#kt_table_users .form-check-input'
        checked={isSelected}
        onChange={() => {
          if (!isDisabled) {
            onSelect(id);
          }
        }}
      />
    </div>
  );
};

export default ProjectSelection;
